import NextImage from 'components/NextImage';
import { Logo as LogoIcon } from '@icons/Logo';

interface LogoProps {
  src?: string;
}

export const Logo = ({ src }: LogoProps) => {
  return src ? (
    <NextImage priority quality={100} src={src} width={78} height={50} alt="Logo image" />
  ) : (
    <LogoIcon />
  );
};
